import {Azienda} from '../models/azienda';
import {Anno} from '../models/anno';
export class LulemployeeData {
  azienda: Azienda;
  anno: Anno;
}
